import Api from "@/services/api/Api.js";

const FormContato = dados => {
  return Api().post("/forms/contato", dados);
};

const GetContato = token => {
  return Api().get("/forms/contato", {
    //corfirmar com o back
    headers: {
      Authorization: `Bearer ${token}`
    }
  });
};

const GetSheet = (token, filename) => {
  return Api().get(`/files/sheets/contatos/${filename}`, {
    responseType: "blob",
    headers: {
      Authorization: `Bearer ${token}`
    }
  });
};

export default {
  GetContato,
  GetSheet,
  FormContato
};
